import { AustinRsvp, getStaticProps } from '@public/AustinRsvp'

export { getStaticProps }

export default AustinRsvp
